import { z } from 'zod/v4';

import { productLicenseSummarySchema } from './product-license-summary.schema';

export const partnerLicenseSummarySchema = z.object({
  productLicenseSummary: z.array(productLicenseSummarySchema),
  totalActivatedLicenses: z.number(),
  totalAllocatedLicenses: z.number(),
  totalAssignedLicenses: z.number(),
});

export type PartnerLicenseSummary = z.infer<typeof partnerLicenseSummarySchema>;
